import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './styles/Global.css';
import './App.css';
import Layout from './components/Layout/Layout';
import Dashboard from './views/Dashboard';
import ContractForm from './components/ContractForm';
import EventsPage from './components/EventsPage';
import EventForm from './components/EventForm';
import SingersPage from './components/SingersPage';
import UserManagement from './components/UserManagement';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Calendar from './components/Calendar';
import EventDetailsPage from './components/EventDetailsPage';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));


  useEffect(() => {
    // Check if token is expired
    if (isAuthenticated) {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const payload = JSON.parse(atob(token.split('.')[1]));
          if (Date.now() >= payload.exp * 1000) {
            localStorage.removeItem('token');
            setIsAuthenticated(false);
          }
        } catch (error) {
          // Invalid token, remove it
          localStorage.removeItem('token');
          setIsAuthenticated(false);
        }
      }
    }
  }, [isAuthenticated]);

  const ProtectedLayout = ({ children, ...props }) => (
    <ProtectedRoute {...props}>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
        <Route path="/" element={<ProtectedLayout><Dashboard /></ProtectedLayout>} />
        <Route path="/contractForm" element={<ProtectedLayout><ContractForm /></ProtectedLayout>} />
        <Route path="/events" element={<ProtectedLayout><EventsPage /></ProtectedLayout>} />
        <Route path="/events/:eventId" element={<ProtectedLayout><EventDetailsPage /></ProtectedLayout>} />
        <Route path="/calendar" element={<ProtectedLayout><Calendar /></ProtectedLayout>} />
        <Route path="/add-event" element={<ProtectedLayout><EventForm /></ProtectedLayout>} />
        <Route path="/edit-event/:eventId" element={<ProtectedLayout><EventForm /></ProtectedLayout>} />
        <Route path="/singers" element={<ProtectedLayout requiredRole="admin"><SingersPage /></ProtectedLayout>} />
        <Route path="/user-management" element={<ProtectedLayout requiredRole="admin"><UserManagement /></ProtectedLayout>} />
      </Routes>
    </Router>
  );
}

export default App;
